export const test = [
  {
    title: 'Numerical Reasoning Practice Test',
    img: 'numerical.jpeg',
    link: '/practice-numerical-test/',
    color: '#257abd',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-numerical-test?tid1=practice-numerical-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Verbal Reasoning Practice Test ',
    img: 'verbal.jpeg',
    link: '',
    color: '#5cbfe9',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-verbal-test?tid1=practice-verbal-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Inductive Reasoning Practice Test',
    img: 'inductive.jpeg',
    color: '#37ba86',
    link: '',
    count: '9',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-inductive-reasoning?tid1=practice-inductive-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Abstract Reasoning Practice Test',
    color: '#b9a44c',
    img: 'cover-abstract.png',
    link: '',
    count: '9',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-abstract-test?tid1=practice-abstract-reasoning-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Cognitive Ability Practice Test',
    color: '#fa7921',
    img: 'cover-cognitive.png',
    link: '',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-ccat-test?tid1=practice-aptitude-tests&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Deductive Reasoning Practice Test',
    color: '#d81159',
    img: 'cover-deductive.png',
    link: '',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-deductive-test?tid1=practice-deductive-reasoning-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Logical Reasoning Practice Test',
    color: '#254e70',
    img: 'cover-logical.png',
    link: '',
    count: '8',
    redirectUrl:
      'https://tests.practicereasoningtests.com/logical-reasoning?tid1=practice-logical-reasoning-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Mechanical Reasoning Practice Test',
    color: '#840032',
    img: 'cover-mechanical.png',
    link: '',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-watson-glaser?tid1=practice-mechanical-reasoning-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Watson Glaser Practice Test',
    color: '#ffd046',
    img: 'cover-watson-graser.png',
    link: '',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-watson-glaser?tid1=practice-watson-glaser-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Situational Judgement Practice Test ',
    color: '#64b6ac',
    img: 'cover-stuational.png',
    link: '',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-sjt-test?tid1=practice-situational-judgement-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Spatial Reasoning Practice Test',
    color: '#007f48',
    img: 'cover-spatial.png',
    link: '',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-spatial-test?tid1=practice-spatial-awareness-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'SHL Practice Reasoning Test',
    color: '#5cbfea',
    img: 'cover-shl.png',
    link: '',
    count: '10',
    redirectUrl:
      'https://tests.practicereasoningtests.com/aptitude-test?tid1=practice-shl-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Diagrammatic Reasoning Test',
    color: '#5cbfea',
    img: 'cover-diagrammatic.png',
    link: '',
    count: '8',
    redirectUrl:
      'https://l.linklyhq.com/l/J83A?tid1=practice-diagrammatic-reasoning-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Practice Critical Thinking Test',
    color: '#17bbcd',
    img: 'cover-capp.png',
    link: '',
    count: '3',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-watson-glaser?tid1=practice-critical-thinking-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'This Practice Error Checking Test',
    color: '#247abf',
    img: 'cover-error.png',
    link: '',
    count: '3',
    redirectUrl:
      'https://tests.practicereasoningtests.com?tid1=practice-error-checking-test&tid2=quizzes&tid3=articles&tid4=PRT',
  },
  {
    title: 'Practice In-Tray Exercise',
    color: '#37ba85',
    img: 'cover-intray.png',
    link: '',
    count: '3',
    redirectUrl:
      'https://tests.practicereasoningtests.com/free-in-tray-test?tid1=practice-in-tray-exercise&tid2=quizzes&tid3=articles&tid4=PRT',
  },
]
export default test
